module.exports = __webpack_public_path__ + "img/374-341aa5.png";